import {useLocation} from 'react-router-dom';
import styled from 'styled-components';
import {
  AssetIconCreateEvent,
  AssetIconDashboard,
  AssetIconEmployees,
  AssetIconEyeOpen,
  AssetIconSettings,
} from '../../../../assets';
import {AdminWebRoute} from '../../../../routes/AdminWebRoute';
import {PaddingBottom} from '../../../padding/PaddingBottom';
import {SidebarGroupTitle} from './components/SidebarGroupTitle';
import {SidebarItem} from './components/SidebarItem';
import {useI18n} from '../../../../hooks';

interface MenuItemsContainerProps {
  isCollapsed: boolean;
  onMenuClick?: () => void;
}

const StyledMenuItemsContainer = styled.div<{isCollapsed: boolean}>`
  padding-left: ${props => (props.isCollapsed ? undefined : '0%')};
`;

export const MenuItemsContainer = ({
  isCollapsed,
  onMenuClick,
}: MenuItemsContainerProps) => {
  const location = useLocation();
  const currentRoute = location.pathname; // Get the current route from URL
  const t = useI18n();

  return (
    <StyledMenuItemsContainer isCollapsed={isCollapsed}>
      <SidebarGroupTitle
        isCollapsed={isCollapsed}
        text={t.navigation.general}
      />
      <SidebarItem
        title={t.navigation.dashboard}
        to={AdminWebRoute.Dashboard}
        icon={<AssetIconDashboard />}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />
      <SidebarItem
        title={t.navigation.createEvent}
        to={AdminWebRoute.CreateEvent}
        icon={<AssetIconCreateEvent />}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />
      <SidebarItem
        title={t.navigation.employeeOverview}
        to={AdminWebRoute.EmployeesOverview}
        icon={<AssetIconEmployees />}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />

      <SidebarItem
        title={t.navigation.eventsOverview}
        to={AdminWebRoute.EventsOverview}
        icon={<AssetIconEyeOpen />}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />

      <SidebarItem
        title={t.navigation.interestAnalytics}
        to={AdminWebRoute.InterestAnalytics}
        icon={<AssetIconEyeOpen />}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />
      <SidebarItem
        title={t.navigation.eventAnalytics}
        to={AdminWebRoute.EventAnalytics}
        icon={<AssetIconEyeOpen />}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />
      <SidebarItem
        title={t.navigation.settings}
        to={AdminWebRoute.Settings}
        icon={<AssetIconSettings />}
        currentRoute={currentRoute}
      />
    </StyledMenuItemsContainer>
  );
};
